const createStateItemData = (item, tusState, options, parallelIdentifier, orgItemId) => {
  tusState.updateState(state => {
    state.items[item.id] = {
      id: item.id,
      uploadUrl: null,
      size: item.file.size,
      offset: 0,
      parallelIdentifier,
      orgItemId
    };
  });
};
export default createStateItemData;